<template>
  <div>
    <div class="ContainerSearchInput">
      <div class="textRegister">
        <span>Clientes Registrados</span>
      </div>
      <div class="searchInput" style="height: 100%; align-items: flex-end">
        <b-form-select
          v-if="showFilterTypes"
          id="filterType"
          class="searchFilterTypes"
          size="sm"
          value-field="value"
          text-field="text"
          v-model="filterType"
          :options="filterTypes"
        ></b-form-select>

        <b-form-select
          class="searchFilter"
          :style="
            showFilterTypes && `border-left: none; border-radius: 0 0 0 0`
          "
          size="sm"
          value-field="value"
          text-field="text"
          v-model="type"
          :options="filterCombobox"
          @change="handleShowFilterTypes"
        ></b-form-select>

        <b-input
          size="sm"
          placeholder="Pesquisar"
          v-model="textPesquisa"
          class="inputSearch"
          @keyup.enter="readCustomers(page)"
        ></b-input>
        <b-button size="sm" @click="handleClickSearch" class="searchBtn">
          <b-icon-search></b-icon-search>
        </b-button>
        <div class="searchInput" style="justify-content: flex-end">
          <button class="searchAll" @click="handleReadAll">ver tudo</button>
          <button class="searchAll" @click="$bvModal.show('modal-close1')">
            Exportar
          </button>
        </div>
      </div>
    </div>
    <div class="ContentTable">
      <table style="width: 100%">
        <thead class="headTable">
          <tr style="width: 100%">
            <th></th>
            <th>Nome</th>
            <th>CPF/CNPJ</th>
            <th>Contato</th>
            <th>Cidade/UF</th>
            <th>Status</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody v-if="this.dataLength > 0" style="color: #3a4750; width: 100%">
          <tr v-for="customer in customers" class="trTable" :key="customer.id">
            <td>{{ customer.codigo }}</td>
            <td>{{ customer.nome }}</td>
            <td>{{ customer.cpfCnpj || "--" }}</td>
            <td class="wtsTd" @click="redirectWhatsApp(customer.celular)">
              {{ customer.celular || "--" }}
              <div v-if="customer.celular">
                <img class="whatsapp" :src="whatsapp" />
              </div>
            </td>
            <td>{{ customer.cidade || "--" }} {{ customer.uf }}</td>
            <td>{{ customer.status }}</td>
            <td>
              <div class="btnActions">
                <b-dropdown
                  id="dropdown-1"
                  text="Ações"
                  menu-class="w-1"
                  class="btnActions"
                  size="sm"
                  variant="none"
                >
                  <template #button-content>
                    <b-icon-gear-fill class="contentActions"></b-icon-gear-fill>
                  </template>
                  <b-dropdown-item @click="findById(customer)">
                    Editar
                  </b-dropdown-item>
                  <b-dropdown-item @click="destroyCustomer(customer.id)">
                    Excluir
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <td colspan="5">
            <div class="defaultSearch">
              <span>Não há dados para exibir ...</span>
            </div>
          </td>
        </tbody>
        <div v-if="spinGeneral" class="loadingLazy">
          <div class="loader"></div>
        </div>
      </table>
    </div>
    <div class="setBtn">
      <button @click="previousPage" :disabled="page === 1" class="itemBtn">
        <b-icon-chevron-left></b-icon-chevron-left>
      </button>
      <button class="centerItemBtn">{{ page }}</button>
      <button @click="nextPage" :disabled="this.dataLength < 9" class="itemBtn">
        <b-icon-chevron-right></b-icon-chevron-right>
      </button>
    </div>
    <b-modal id="modal-close1" hide-footer hide-header centered>
      <div>
        <div v-if="spinExport" class="loadingLazyClose">
          <div class="loader"></div>
        </div>
        <div class="contentTitleClose">
          <h6 class="titleModalReversalOrDeleteClose">Confirmar exportação</h6>
        </div>

        <section
          style="
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 20px;
            margin-top: 20px;
            margin-bottom: 15px;
            padding: 0 10px;
          "
        >
          <div style="width: 100%">
            <p class="subTitleClose" style="margin: 0">
              Você está prestes a exportar os dados dos clientes cadastrados!
            </p>
          </div>

          <div style="width: 100%">
            <b-form-checkbox
              class="footerTitleClose"
              size="sm"
              id="checkbox-1"
              v-model="confirmProcess"
              name="checkbox-1"
            >
              Estou ciente e desejo exportar.
            </b-form-checkbox>
          </div>

          <div class="rowContainerClose" style="width: 100%">
            <span>Informe a Senha:</span>
            <div class="rowContentClose">
              <div class="input-group" style="width: 100%">
                <input
                  type="password"
                  required
                  class="input borderInputClose"
                  v-model="comparePass"
                />
              </div>
            </div>
          </div>
        </section>

        <div class="btnsModalActionsClose">
          <button class="btnCancelClose" @click="$bvModal.hide('modal-close1')">
            Não
          </button>
          <button
            class="btnConfirmClose"
            @click="exportToExcel"
            style="position: relative"
            :disabled="!confirmProcess"
          >
            Sim, exportar
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import searchCustomer from "../../mixins/Customer/Search";
import { mapMutations, mapState } from "vuex";
import serviceCustomer from "../../services/serviceCustomer";
import whatsapp from "../../assets/whatsapp.svg";
import * as XLSX from "xlsx";

export default {
  props: {
    getAllCustomer: {
      type: Boolean,
    },
  },
  mixins: [searchCustomer],

  data() {
    return {
      textPesquisa: "",
      type: "",
      startDate: "",
      endDate: "",
      customers: [],
      customersExcel: [],
      confirmProcess: false,
      comparePass: "",
      password: "margarida",
      spinExport: false,
      page: 1,
      whatsapp: whatsapp,
      filterCombobox: [
        { value: "nome", text: "Nome" },
        { value: "codigo", text: "Código" },
        { value: "cpfCnpj", text: "CPF/CNPJ" },
        { value: "celular", text: "Contato" },
        { value: "status", text: "Status" },
        { value: "endereco", text: "Endereco" },
        { value: "cidade", text: "Cidade" },
        { value: "cep", text: "CEP" },
        { value: "", text: "Todos" },
      ],
      filterTypes: [
        { value: "includes", text: "Contém" },
        { value: "start", text: "Inicia por" },
      ],
      filterType: "start",
      showFilterTypes: false,
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_CUSTOMER",
    ]),
    async findById(client) {
      try {
        const result = await serviceCustomer.findById(client.id);
        this.openModalToReceive(result);
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED")) {
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        } else {
          this.$toast.open({
            message: "Ocorreu um eror ao buscar o cliente!",
            type: "error",
          });
        }
      }
    },

    async handleReadAll() {
      this.clearSearch();
      await this.readCustomers(this.page);
    },

    async handleClickSearch() {
      this.page = 1;
      await this.readCustomers(1);
    },
    async searchAll() {
      try {
        this.spinExport = true;
        const result = await serviceCustomer.findAllExport();
        this.customersExcel = result.data;
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED")) {
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        } else {
          this.$toast.open({
            message: "Ocorreu um eror ao buscar o cliente!",
            type: "error",
          });
        }
      } finally {
        this.spinExport = false;
      }
    },
    async exportToExcel() {
      if (this.comparePass !== this.password) {
        this.$toast.open({
          message: "Senha incorreta para exportar os dados!",
          type: "error",
        });
        return;
      }
      await this.searchAll();
      const header = [
        "Nome",
        "CPF / RG",
        "Whatsapp",
        "Email",
        "Endereço",
        "Cidade",
        "UF",
      ];

      const data = this.customersExcel.map((c) => [
        c.nome,
        c.cpfCnpj || "--",
        c.celular || "--",
        c.email || "--",
        `${c.endereco || "--"} - ${c.bairro || "--"}, ${c.numero || "S/N"}`,
        c.cidade || "--",
        c.uf || "--",
      ]);

      data.unshift(header);
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Clientes");
      XLSX.writeFile(workbook, "Clientes.xlsx");
    },

    openModalToReceive(customers) {
      this.SET_DATA_SEARCH_FROM_CUSTOMER(customers);

      const name = "customer";
      this.ALTER_TYPE_REGISTER(name);
      this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral");
      this.SET_COLAPSE_REGISTER(true);
      this.ALTER_MODAL_CONTAINER_REGISTER("modalContainer");
    },

    redirectWhatsApp(number) {
      const formatedNumber = number.replace(/\D/g, "");
      const url = `https://wa.me/55${formatedNumber}`;
      window.open(url, "_blank");
    },

    handleShowFilterTypes() {
      const types = ["nome", "cpfCnpj", "celular", "endereco", "cidade", "cep"];

      if (types.includes(this.type)) {
        this.showFilterTypes = true;
        return;
      }

      this.showFilterTypes = false;
    },
  },
  computed: {
    ...mapState({
      isSearchRegisters: (state) => state.isSearchRegisters,
    }),
  },
  watch: {
    async getAllCustomer() {
      await this.readCustomers(1);
    },
    isSearchRegisters() {
      this.readCustomers();
    },
  },
};
</script>

<style scoped>
.ContentTable {
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 10px;
  width: 100%;
  max-width: 100%;
}

.headTable {
  color: whitesmoke;
  background: #3a4750;
  text-align: center;
  height: 29px;
}

.trTable {
  text-align: center;
  height: 29px;
  cursor: context-menu;
  font-size: 12px;
}

tr:nth-child(even) {
  background: #f2f3f3;
}

th {
  font-weight: 500;
  font-size: 12px;
}

td {
  text-transform: capitalize;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.btnActions {
  height: 25px;
  display: flex;
  justify-content: center;
}

.whatsapp {
  width: 20px;
  height: 20px;
}

.wtsTd {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding-top: 5px;
  cursor: pointer;
}

.wtsTd:hover {
  background: rgb(213, 213, 213);
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.searchFilter {
  width: 150px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
}

.searchFilter:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.searchFilterTypes {
  width: 150px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
}

.searchFilterTypes:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.custom-select {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid rgb(195, 193, 193);
  -moz-appearance: none;
  appearance: none;
}

.ContainerSearchInput {
  display: flex;
  align-items: center;
  height: 37px;
  width: 100%;
  justify-content: space-between;
  padding: 0 20px;
}

.textRegister span {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.searchInput {
  white-space: nowrap;
  gap: 5px;
  width: 50%;
  display: flex;
}

.searchAll {
  justify-content: center;
  color: #3a4750;
  font-size: 13px;
  padding: 5px 20px;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}

.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
}

input {
  border: 1px solid rgb(195, 193, 193);
  border-radius: 5px;
  height: 30px;
}

.searchBtn {
  right: 10px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #c3c1c1;
}

input:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

button:focus {
  box-shadow: none;
}

.pagMonth {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.defaultSearch {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 20vh;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
}

.defaultSearch span {
  font-size: 1rem;
  font-weight: bold;
  color: gray;
}

.loadingLazy {
  position: absolute;
  bottom: 20px;
  height: 50vh;
  width: calc(100% - 100px);
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(140, 140, 140);
}

.loadingLazyClose {
  position: absolute;
  bottom: 20px;
  height: 50vh;
  width: calc(100% - 20px);
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(140, 140, 140);
}

.setBtn {
  display: flex;
  flex-direction: row;
  margin: 0 1rem 1rem 0;
  gap: 10px;
  bottom: 0;
  right: 0;
  position: absolute;
}

.itemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #3a4750;
}

.itemBtn:hover {
  background: #3a4750;
  color: whitesmoke;
}

.itemBtn:disabled {
  opacity: 0;
}

.centerItemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #1b3159;
  cursor: auto;
}

.loader {
  animation: rotate 1s infinite;
  height: 50px;
  width: 50px;
  opacity: 0.5;
}

.loader:before,
.loader:after {
  border-radius: 50%;
  content: "";
  display: block;
  height: 20px;
  width: 20px;
}

.loader:before {
  animation: ball1 1s infinite;
  background-color: #403b74;
  box-shadow: 30px 0 0 #f2a83e;
  margin-bottom: 10px;
}

.loader:after {
  animation: ball2 1s infinite;
  background-color: #3e66ae;
  box-shadow: 30px 0 0 #48b865;
}

.contentTitleClose {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  padding: 10px;
  background-color: #0188c8;
  border-radius: 5px;
  color: white;
  margin: 0;
}

.subTitleClose {
  color: #767676;
  font-size: 14px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  margin: 0;
}

.titleModalReversalOrDeleteClose {
  font-family: Poppins-Regular, sans-serif !important;
  margin: 0;
  text-align: center;
}

.footerTitleClose {
  color: #0188c8;
  font-size: 13px;
  font-family: Poppins-Regular, sans-serif !important;
  margin: 0;
}

.btnsModalActionsClose {
  margin-top: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btnConfirmClose {
  font-size: 11px;
  border: 1px solid #0188c8;
  border-radius: 3px;
  width: 40%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #0188c8;
}

.btnCancelClose {
  font-size: 11px;
  border: 1px solid #0188c8;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #0188c8;
  background: white;
}

.rowContainerClose {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 10px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowContainerClose span {
  font-weight: 600;
}

.rowContentClose {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}

.borderInputClose {
  font-size: 12px;
  height: 30px;
  width: 100%;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInputClose:focus {
  border: 1px solid #505050;
}

@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(0.8);
    -moz-transform: rotate(0deg) scale(0.8);
  }

  50% {
    -webkit-transform: rotate(360deg) scale(1.2);
    -moz-transform: rotate(360deg) scale(1.2);
  }

  100% {
    -webkit-transform: rotate(720deg) scale(0.8);
    -moz-transform: rotate(720deg) scale(0.8);
  }
}

@keyframes ball1 {
  0% {
    box-shadow: 30px 0 0 #f2a83e;
  }

  50% {
    box-shadow: 0 0 0 #f2a83e;
    margin-bottom: 0;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #f2a83e;
    margin-bottom: 10px;
  }
}

@keyframes ball2 {
  0% {
    box-shadow: 30px 0 0 #48b865;
  }

  50% {
    box-shadow: 0 0 0 #48b865;
    margin-top: -20px;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #48b865;
    margin-top: 0;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .ContainerSearchInput {
    padding: 3px;
  }
  .textRegister {
    font-size: 12px;
  }
  .searchInput {
    width: 60%;
  }
  .searchFilter {
    height: 25px;
    font-size: 11px;
  }
  .form-control-sm {
    padding: 0.25rem 1.2rem;
    height: 25px;
    font-size: 12px;
  }
  .searchBtn {
    right: 10px;
    height: 25px;
    display: flex;
    align-items: center;
  }
  .searchAll {
    font-size: 11px;
    padding: 2px 10px;
  }
  .ContentTable {
    height: 50vh;
    max-height: 50vh;
    padding: 5px;
  }
  .headTable {
    height: 25px;
  }
  .trTable {
    height: 25px;
    font-size: 11px;
  }
  .setBtn {
    margin: 0 1rem 10px 0;
  }

  .itemBtn {
    width: 18px;
    height: 18px;
  }

  .centerItemBtn {
    width: 18px;
    height: 18px;
  }
}

@media screen and (max-width: 700px) {
  .ContainerSearchInput {
    display: flex;
    align-items: center;
    height: 70px;
    gap: 5px;
    width: 100%;
    justify-content: center;
    padding: 0;
    flex-direction: column;
  }

  .searchInput {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 3px 0 0;
  }

  .ContentTable {
    padding: 5px;
  }

  .trTable {
    font-size: 9px;
  }

  .whatsapp {
    display: none;
  }
}
</style>
